jQuery(document).ready(function () {
    if ($('.expertisemain').length > 0) {
        // var youtubeThumbnail = require('../../../../../assets-builder/node_modules/youtube-thumbnail');
        var href = $(".expertisemain_video").data("link");
        console.log(href);
        // var thumbnail = youtubeThumbnail(href);
        // var backgroundImg = thumbnail.high.url;
        $(".expertisemain_card-video").css("background-image", "url(" + href + ")");
    }
    if (window.matchMedia("(max-width: 1023px)").matches) {
        $('.expertisemain_carousel').slick({
            speed: 300,
            slidesToShow: 1,
            variableWidth: true,
            dots: true,
            infinite: false
        });
    }

});
